<template>
  <nav
    class="navbar is-dark"
    role="navigation"
    aria-label="main navigation">
    <div class="navbar-brand">
      <router-link
        to="/"
        class="navbar-item">RFI</router-link>
    </div>
    <div
      v-if="fullName !== ''"
      class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            {{ fullName }}
          </a>

          <div class="navbar-dropdown is-right">
            <!-- <hr class="navbar-divider"> -->
            <a
              class="navbar-item"
              @click="logout">
              Log Out
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { logout } from '../utils/auth'

export default {
  name: 'app-nav',
  props: {
    'full-name': {
      type: String,
      default: ''
    }
  },
  methods: {
    logout: function() {
      logout()
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
nav {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppNav.vue